import { ChevronDownIcon, ChevronRightIcon } from '@heroicons/react/24/outline';
import clsx from 'clsx';

import { Button } from '../Button';

interface SectionHeadingProps {
  text: string;
  isExpanded: boolean;
  setIsExpanded: (isExpanded: boolean) => void;
  onTextClick?: (link: string) => void;
  titleLink?: string;
}

export default function SectionHeading({
  text,
  setIsExpanded,
  isExpanded,
  onTextClick,
  titleLink,
}: SectionHeadingProps) {
  return (
    <div
      className={clsx(
        'group flex w-full items-center justify-between ',
        titleLink ? 'cursor-pointer px-2' : 'px-6',
      )}
    >
      <span
        className={clsx(
          'w-full text-base font-semibold leading-6',
          titleLink
            ? 'mb-2 cursor-pointer rounded-lg py-1 px-4 text-blue-600 duration-200 hover:bg-blue-100 hover:text-blue-700 hover:ring-2 hover:ring-blue-300'
            : 'text-gray-600',
        )}
        onClick={
          titleLink && onTextClick ? () => onTextClick(titleLink) : undefined
        }
      >
        {text}
      </span>
      <Button
        className={clsx(
          'flex h-8 w-8 items-center justify-center p-1 text-gray-500 hover:text-blue-400',
          isExpanded && 'text-blue-400',
        )}
        onClick={() => setIsExpanded(!isExpanded)}
      >
        {isExpanded ? <ChevronRightIcon /> : <ChevronDownIcon />}
      </Button>
    </div>
  );
}
